import classNames from "classnames";
import { ErrorMessage } from "./ErrorMessage.tsx";
import { WarningMessage } from "./WarningMessage.tsx";

export const ErrorWrapper = ({
  children,
  errors,
  warnings,
  errorsChildren,
  className,
}: {
  children: React.ReactNode;
  errors?: string[];
  warnings?: string[];
  errorsChildren?: React.ReactNode;
  className?: string;
}) => (
  <div className={classNames("flex-col gap-200", className)}>
    {children}
    {warnings && warnings.length > 0 ? (
      <div className="flex-col gap-100">
        {warnings.map((warning, index) => (
          <WarningMessage key={index} text={warning} />
        ))}
      </div>
    ) : null}
    {errors && errors.length > 0 ? (
      <div className="flex-col gap-100">
        {errors.map((error, index) => (
          <ErrorMessage key={index} text={error} />
        ))}
        {errorsChildren}
      </div>
    ) : null}
  </div>
);
